import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=1f016246&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports